import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import Button from '@carvana/core-helios-button';
import { useMileage } from '@components/service-and-repair/hooks/use-mileage';
import styles from '../../service-and-repair.module.css';
import localStyles from './mileage-too-high.module.css';
import { ROUTES, useRouter } from '../../providers/router';
import { useUserSelections } from '../../providers/user-selections';

export const MileageTooHigh = () => {
  const { goToRoute, completeFormStep } = useRouter();
  const { userSelections } = useUserSelections();
  const { deleteSavedMileage } = useMileage();
  const formattedMileage = (userSelections?.mileage || 0)?.toLocaleString();

  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarConfirmMileageViewed, { mileageValue: formattedMileage });
    datadogRum.addAction(AnalyticEvents.sarConfirmMileageViewed, { mileageValue: formattedMileage });
    deleteSavedMileage();
  }, []);

  const handleEdit = () => {
    goToRoute(ROUTES.MILEAGE);
    Analytics.trackEvent(AnalyticEvents.sarConfirmMileageClickedEditMileage, { mileageValue: formattedMileage });
    datadogRum.addAction(AnalyticEvents.sarConfirmMileageClickedEditMileage, { mileageValue: formattedMileage });
  };

  const handleConfirm = () => {
    completeFormStep(ROUTES.MILEAGE);
    Analytics.trackEvent(AnalyticEvents.sarConfirmMileageClickedItsCorrect, { mileageValue: formattedMileage });
    datadogRum.addAction(AnalyticEvents.sarConfirmMileageClickedItsCorrect, { mileageValue: formattedMileage });
  };

  return (
    <div className={styles['page-wrapper']}>
      <div className={styles['page-header']}>
        <h2>The mileage you entered seems too high. Can you confirm this is correct?</h2>
      </div>

      <div className={localStyles['high-mileage']}>{formattedMileage}</div>

      <div className={styles['button-wrapper']}>
        <Button priority="secondary" onClick={handleEdit}>
          Edit mileage
        </Button>
        <Button onClick={handleConfirm}>Confirm</Button>
      </div>
    </div>
  );
};

export default MileageTooHigh;
